import {
  LOGIN_DELIVERY_USER,
  LOGOUT_DELIVERY_USER,
  UPDATE_DELIVERY_USER_INFO,
  UPDATE_DELIVERY_ORDER_HISTORY
} from "./actionTypes";

const initialState = {
    delivery_user: {
        data: null,
        success: false,
        fetched: false,
    },
    order_history: [],
};


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_DELIVERY_USER:
      return {
        ...state,
        delivery_user: {
          ...action.payload,
          fetched: false, // allow refresh after login
        },
      };

    case LOGOUT_DELIVERY_USER:
      return initialState;

    case UPDATE_DELIVERY_USER_INFO:
      return {
        ...state,
        delivery_user: {
          data: action.payload.delivery_user.data,
          success: true,
          fetched: true,
          lastFetchedAt: action.payload.delivery_user.data.lastFetchedAt,
          chart: action.payload.delivery_user.chart,
        },
        order_history: action.payload.order_history,
      };

    case UPDATE_DELIVERY_ORDER_HISTORY:
      return {
        ...state,
        order_history: action.payload,
      };

    default:
      return state;
  }
}

